module.exports = __webpack_public_path__ + "static/SocialDrop-1-dark-8a05c7a3eacf3a5e54fc496de375af9c.svg";